import {ReactNode} from 'react';
import { ClipLoader } from 'react-spinners';

interface LoaderProps {
  isRequesting: boolean,
  children?: ReactNode,
  text?: string,
  noFixedHeight?: boolean
}

const Loader = ({ isRequesting, text, children, noFixedHeight }: LoaderProps) => (
  <>
    {isRequesting ? (
      <div className="loading-circle-container center-loader">
        {text && <p style={{ whiteSpace: 'pre', textAlign: 'center' }}>{text}</p> }
        <div className={noFixedHeight ? '' : 'loading-circle'}>
          <ClipLoader id="_towngen-loader" />
        </div>
      </div>
    ) : null}
    {!isRequesting && children ? children : null}
  </>
);

export default Loader;
